// extracted by mini-css-extract-plugin
export var phone = "_4k-0";
export var phoneDragging = "_4k-1";